import { routerThreeDsV3 } from "./routerThreeDsV3";
import { repeatedRequest } from "./repeatedRequest";
import { getPage } from "./getPage";



export const processingRessponse = (processing, data) => {
  switch (processing) {
    case 'retry': {
      $('.popup-loading-wrapper').hide()

      $('.valid').removeClass('valid')
      $('.accept').removeClass('accept')

      $('input[name="cardNumber"]').val('')
      $('#cardExpMonth').val('')
      $('#cardExpYear').val('')
      $('input[name="cvv"]').val('')

      $('.form-error-text').html('Declined ‑ Your bank declined transaction. Please try again or use another card').show()

      break
    }
    case 'validating':
      if (data.action) {
        routerThreeDsV3(data)
      } else {
        setTimeout(function () {
          repeatedRequest()
        }, 2500)
      }
      break
    case 'success': {
      window.location.href = getPage('confirmation')
      break
    }
    default:
      $('.popup-loading-wrapper').hide()
      $('.form-error-text').html('Network Error... Please try again').show()
  }
}
